import { FC } from "react";

interface Props {
  words: string[];
}

export const WordWrap: FC<Props> = ({ words }) => {
  return (
    <span className="flex flex-col flex-wrap md:flex-row">
      {words.map((word) => (
        <span key={word}>{word}</span>
      ))}
    </span>
  );
};
